'use client'

import type { UiLanguage } from './types'

interface LabelSource {
  label?: string
  label_cs?: string
  label_en?: string
}

export function localizeFeatureLabel(
  featureKey: string,
  uiLanguage: UiLanguage,
  source?: LabelSource,
): string {
  if (uiLanguage === 'en') {
    return source?.label_en
      || source?.label
      || featureKey.replace(/_/g, ' ')
  }
  return source?.label_cs
    || source?.label
    || featureKey.replace(/_/g, ' ')
}

